export default __webpack_public_path__ + "3ee643f6947b27435bb250d990b9f6f2.png";